<!--
 * @Descripttion: 批量补卡申请列表
 * @Author: jschen
 * @Date: 2021-09-05 14:28:12
 * @LastEditors: chenjinsheng
 * @LastEditTime: 2021-09-23 02:17:31
-->
<template>
    <div v-show="visible" class="right-box">
        <div class="sort-box">
            <div class="sort-title">
                <span>补卡批量审批列表</span>
            </div>
            <div class="search-right-box">
                <div class="sort-right-box">
                    <div class="search-box">
                        <el-input
                            v-model="searchCheckOpt.title"
                            placeholder="标题关键字搜索"
                            prefix-icon="el-icon-search"
                            size="small"
                            @input="handleSearch"
                        >
                        </el-input>
                    </div>
                    <el-button size="mini" class="sActive" @click="submit(true)">
                        审批同意
                    </el-button>
                    <el-button size="mini" class="sActive" @click="submit(false)">
                        审批不同意
                    </el-button>
                    <el-button plain size="mini" @click="refresh">刷新</el-button>
                </div>
            </div>
        </div>
        <el-table
            v-loading="loading"
            :data="checkRecords"
            size="mini"
            border
            style="width: 100%"
            height="calc(100% - 45px)"
            @selection-change="handleSelectionChange"
        >
            <el-table-column type="selection" width="55" align="center"> </el-table-column>
            <el-table-column label="序号" width="55" align="center">
                <template slot-scope="scope">{{ scope.$index + 1 }}</template>
            </el-table-column>
            <el-table-column prop="docSubject" width="400" label="标题" :show-overflow-tooltip="true">
                <template slot-scope="scope">
                    <p @click="rowCheckClick(scope.row.link)">{{ scope.row.docSubject }}</p>
                </template>
            </el-table-column>
            <el-table-column label="处理状态" width="120" align="center">
                <template slot-scope="scope">
                    {{ scope.row.status ? "处理中" : "未处理" }}
                </template>
            </el-table-column>
            <el-table-column prop="startUserName" label="发起人" align="center"> </el-table-column>
            <el-table-column prop="createTime" sortable label="接收时间" width="200" align="center">
                <template slot-scope="scope">
                    <span>{{ format(scope.row.createTime) }}</span>
                </template>
            </el-table-column>
            <div slot="empty" class="empty">
                <img src="@/assets/pics/no-empty.png" />
                <span>暂无内容</span>
            </div>
        </el-table>
    </div>
</template>
<script>
import { batchCheck, submitBatchComplete } from "@/api";
import { getLocalStorage, formatDate } from "@/libs/mUtils";
import _ from "lodash";
export default {
    props: {
        title: {
            type: String,
            default: "",
        },
        visible: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            loading: false,
            username: getLocalStorage("user").oauth.userName,
            checkRecords: [],
            allRecords: [],
            multipleSelection: [],
            searchCheckOpt: {
                title: "", // 标题
            },
        };
    },
    methods: {
        search() {
            this.loadData();
        },
        loadData() {
            this.queryBatchCheckList();
        },
        // 查询已申请列表
        async queryBatchCheckList() {
            this.loading = true;
            try {
                const { body, code, message } = await batchCheck({
                    keys: ["buka"],
                    username: this.username,
                });
                if (code === "0000") {
                    this.checkRecords = body;
                    this.allRecords = body;
                } else {
                    this.$message.error(message);
                }
            } catch (err) {
                console.error(err);
            }
            this.loading = false;
        },
        async submit(bool) {
            if (!this.multipleSelection.length) {
                return this.$message.warning("未选择需要操作的数据！！");
            }
            try {
                const { code, message } = await submitBatchComplete({
                    username: this.username,
                    complete: Number(bool),
                    taskIds: this.multipleSelection,
                    sourceType: "PC",
                    comments: bool ? "同意" : "不同意",
                });

                if (code === "0000") {
                    this.$message({
                        type: "success",
                        message: "审批数据已成功加入处理队列，处理完成后可在待办列表查看处理结果!",
                    });
                    this.queryBatchCheckList();
                } else {
                    this.$message.error(message);
                }
            } catch (err) {
                console.error(err);
                // this.$message.error(err);
            }
        },
        handleSearch() {
            const title = this.searchCheckOpt.title.trim();
            if (title) {
                this.checkRecords = this.allRecords.filter((item) => item.docSubject.includes(title));
            } else {
                this.checkRecords = this.allRecords;
            }
        },
        // 刷新
        refresh() {
            this.reset();
        },
        clearKw() {
            this.searchCheckOpt = {
                title: "", // 标题
            };
        },
        reset() {
            this.searchCheckOpt = {
                title: "", // 标题
            };
            this.loadData();
        },
        format(nS, str) {
            return formatDate(nS, str);
        },
        rowCheckClick(link) {
            this.handleRouterJump(1, link, "", true);
        },
        // 复选框
        handleSelectionChange(taskList = []) {
            this.multipleSelection = taskList.map((item) => item.taskId);
        },
        handleSizeChange(val) {
            this.searchCheckOpt.current = 1;
            this.searchCheckOpt.size = val;
            this.loadData();
        },
        handleCurrentChange(val) {
            this.searchCheckOpt.current = val;
            this.loadData();
        },
    },
};
</script>

<style lang="scss" scoped>
@import "../style.scss";
.sort-right-box {
    .search-box {
        width: 250px;
        margin-right: 12px;
        /deep/ .el-input__inner {
            height: 28px;
            line-height: 28px;
        }
        /deep/ .el-icon-search {
            position: relative;
            top: -1px;
        }
    }
}
</style>
